<template>
  <div class="col-span-5 pt-3 pr-3"
       :class="`border-solid border-0 border-l-2 border-${message.borderColor}`">
    <div class="pt-4"
         :class="isCarousel(message.data.content) ? 'pl-4' : 'grid grid-cols-5'"
    >
      <vx-tooltip :text="tooltipText"
                  :key="tooltipText"
                  position="left"
                  class="justify-end"
                  :class="{ 'col-span-3 col-start-3': !isCarousel(message.data.content) }"
                  delay="0.2s">
        <carousel-preview v-if="isCarousel(message.data.content)"
                          :payload="message.data.content.payload"
        />
        <bubble v-else
                :content="message.data.content"
                :original-content="message.data.originalContent"
                :bubble-classes="isEmailBot ? 'bg-white border border-gray-bubble' : 'border-none'"
                :text-classes="isEmailBot ? 'text-body' : 'text-white whitespace-pre-wrap'"
                :render-html="isEmailBot"
                :quick-reply-classes="quickReplyClasses"
                @context-tooltip-show="handleContextTooltipShow"
                @context-tooltip-hide="handleContextTooltipHide"
        />
      </vx-tooltip>
    </div>
  </div>
</template>

<script>
import Bubble from '../../../preview/Bubble.vue'
import CarouselPreview from '@/components/preview/CarouselPreview.vue'
import datetimeUtils from '@/utils/datetime.utils'

export default {
  name: 'ConversationBotMessage',

  components: {
    Bubble,
    CarouselPreview
  },

  data() {
    return {
      contextKey: null
    }
  },

  computed: {
    tooltipText() {
      const timestamp = this.formatTimestamp(this.message.sent || this.message.timestamp)
      if (this.contextKey) {
        return `${timestamp}
                <div style="font-size: 0.875rem; white-space: nowrap; margin-top: 10px">
                  <b>Interpolation key:</b>
                </div>
                ${this.contextKey}
               `
      }
      return timestamp
    }
  },

  props: {
    message: {
      type: Object,
      required: true
    },
    isEmailBot: {
      type: Boolean,
      default: false
    },
    selectedQuickReplyIndex: {
      type: Number
    }
  },

  methods: {
    isCarousel(content) {
      if (!content) return false
      return content.type === 'structure' && Array.isArray(content.payload)
    },

    formatTimestamp(timestamp) {
      return datetimeUtils.toMoment(timestamp).format('LL HH:mm:ss')
    },

    quickReplyClasses(index) {
      if (index === this.selectedQuickReplyIndex) {
        return 'border-solid border-focus text-focus shadow-focus'
      }

      return 'border-solid border-primary text-primary'
    },

    handleContextTooltipShow(contextKey) {
      this.contextKey = contextKey
    },

    handleContextTooltipHide() {
      this.contextKey = null
    }
  }
}
</script>
<style scoped>
::v-deep a {
  @apply text-white underline;
}
</style>
